// App.js
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import { GqlClient } from "@/services/graph-ql/configs";
import NProgress from "nprogress";
import Router from "next/router";
import CRMLayout from "@/modules/crm/crm-layout";
import "@/styles/globals.css";
import "@/styles/main.scss";
import "intro.js/introjs.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
import envConfig from "@/config.js";
import store from "@/store";
import RouteGuard from "@/routes/route-guard";
import { ToastContainer, Zoom } from "react-toastify";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCountriesToState } from "@/store/slices/general/countriesSlice";
import IdleTimerWrapper from "@/hooks/idleTimer";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Filler,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";
import { CacheProvider } from "@emotion/react";

import createCache from "@emotion/cache";
import { ThemePalettes } from "@/services/theme-palettes";

// Create a custom cache instance
const cache = createCache({ key: "custom" });

NProgress.configure({
  showSpinner: false,
});

Router.events.on("routeChangeStart", () => {
  NProgress.start();
});

Router.events.on("routeChangeComplete", () => NProgress.done());

Router.events.on("routeChangeError", () => NProgress.done());

config.autoAddCss = false;

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  TimeScale,

  Title,
  Tooltip,
  Legend,
  Filler
);

const App = ({ Component, pageProps }) => {
  const Layout = Component.Layout || EmptyLayout;
  const isAuthLayout = Component.isAuthLayout;
  const hideLoading = Component.hideLoading;
  // const dispatch = useDispatch()
  // Disable console logs on production
  if (!envConfig.allowConsoles) {
    console.log = function () {};
  }
  useEffect(() => {
    console.log("app country");
    // Fetch the JSON data from the file
    fetch("/mock-data/leads/country_info.json")
      .then((response) => response.json())
      .then((data) => {
        // setCountries(data);
        store.dispatch(setCountriesToState(data));
      })
      .catch((error) => {
        console.error("Error fetching countries data:", error);
      });
  }, []);

  useEffect(() => {
    // Inject CSS variables into the :root
    // Inject default CSS variable here for public screens
    let defaultTheme = ThemePalettes["default_theme"];
    const root = document.documentElement;
    if (defaultTheme?.custom) {
      Object.entries(defaultTheme?.custom).forEach(([key, value]) => {
        root.style.setProperty(`--palette-${key}`, value);
      });
    }
  }, []);
  // const { store, props } = wrapper.useWrappedStore(rest);
  // const { pageProps } = props;

  return (
    <CacheProvider value={cache}>
      <ApolloProvider client={GqlClient}>
        <Provider store={store}>
          {isAuthLayout ? (
            <Layout hideLoading={hideLoading}>
              <Component {...pageProps} />
            </Layout>
          ) : (
            <RouteGuard>
              <CRMLayout>
                <Layout>
                  <IdleTimerWrapper idleTime={envConfig?.idleTimeLimit}>
                    <Component {...pageProps} />
                  </IdleTimerWrapper>
                </Layout>
              </CRMLayout>
            </RouteGuard>
          )}
        </Provider>
        <ToastContainer
          hideProgressBar={true}
          autoClose={5000}
          // theme="light"
          theme="colored"
          position="top-center"
          transition={Zoom}
          style={{
            top: "4rem",
            zIndex: "100000", // increased due to grid overlay zIndex
          }}
        />
      </ApolloProvider>
    </CacheProvider>
  );
};

const EmptyLayout = ({ children }) => <>{children}</>;

export default App;
